module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0003.jpg?v=7adad6ea";